import React from "react";
import "./style.css";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { ReactComponent as UserImg } from "../../assets/img/maleAvatar.svg";
import FraemIcon from "../../assets/svg/FraemIcon";
import SettingsIcon from "@mui/icons-material/Settings";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import NewspaperTwoTone from "@mui/icons-material/NewspaperTwoTone";
import {DEFAULT_BACKEND_URL} from "../../helpers/env";

import { useStore } from "_Store";
import Store from "_Store";

const AppBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [ isLoading, setIsLoading ] = React.useState(true);
  const { state:{auth: { token, isAuth, user } } } = useStore();
  //const { data: user, isLoading } = useUserData();
  React.useEffect(() => {
    setIsLoading(false)
   }, [user]);
 
  const handleNavigate = (path) => {
    navigate(path);
  };

  
  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const [tabIndex, setTabIndex] = React.useState(
    { "/farms": 0, "/farms": 1, "/settings": 2 }[location.pathname] || 0
  );

  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };
  return (
    <div className="w-full sm:max-w-screen-2xl mx-auto flex flex-col">
      <div className="user_header">
        <div className="user_img">
          <div
            style={{
              display: "flex",
              paddingRight: "51px",
              borderRight: "1px solid #eee",
              placeItems: "center",
            }}
          >
            <div className="user_imgs">
              {
               !isLoading && user?.profilePicture
                ? <img src={`${DEFAULT_BACKEND_URL}/profile/${user.profilePicture}`} crossOrigin="anonymous"
                style={{verticalAlign: "middle",  width: 50,
                        height: 50, borderRadius:  100}} alt=""/>
                : <UserImg />
              }
            </div>
            <div>
              <Typography color="secondary.main" fontSize={16}>
                Exploitant agricole
              </Typography>
              <Typography fontWeight={500} fontSize={20}>
                {isLoading ? "" : `${user?.firstName} ${user?.lastName}`}
              </Typography>
            </div>
          </div>
          <div className="Appbatabbtn">
            <Box className="feremtabn">
              <nav>
                <ul className="nav nav-pills pull-right">
                  <NavLink className="tabbtn" to={"/farms"}>
                    <FraemIcon />
                    <span>Champs</span>
                  </NavLink>
                  <NavLink className="tabbtn" to="/formations">
                    <NewspaperTwoTone />
                    <span> Formations</span>
                  </NavLink>
                  <NavLink className="tabbtn" to={"/settings"}>
                    <SettingsIcon />
                    <span> Paramètres</span>
                  </NavLink>
                </ul>
              </nav>
            </Box>
          </div>
          <div>
            {/* <button onClick={() => handleNavigate("/dashboard")}>
              <img src={HomeIcon} />
              Accueil
            </button> */}
          </div>
          <div>
            {/* <button>
              <img src={fraemIconTab} />
              Champs
            </button> */}
          </div>
          <div>
            {/* <button>           
              <SettingsIcon />
              Paramètres
            </button> */}
          </div>
        </div>
        {/* <div className="notifiaction_bar">
          <div className="notifiaction_status">
            <span>3</span>
            <img src={Notification} />
          </div>
          Notification
        </div> */}
      </div>
    </div>
  );
};

export default AppBar;
